/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a conversation category
 * @export
 * @interface BridgeApiConversationCategory
 */
export interface BridgeApiConversationCategory {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversationCategory
     */
    handle?: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversationCategory
     */
    name: string;
}

/**
 * Check if a given object implements the BridgeApiConversationCategory interface.
 */
export function instanceOfBridgeApiConversationCategory(value: object): value is BridgeApiConversationCategory {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BridgeApiConversationCategoryFromJSON(json: any): BridgeApiConversationCategory {
    return BridgeApiConversationCategoryFromJSONTyped(json, false);
}

export function BridgeApiConversationCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiConversationCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'] == null ? undefined : json['handle'],
        'name': json['name'],
    };
}

export function BridgeApiConversationCategoryToJSON(json: any): BridgeApiConversationCategory {
    return BridgeApiConversationCategoryToJSONTyped(json, false);
}

export function BridgeApiConversationCategoryToJSONTyped(value?: BridgeApiConversationCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'name': value['name'],
    };
}

